export const VERSION = ((require('../package.json')).version || 'n.d.')
export const TOKENUPLOAD = process.env.VUE_APP_TOKENUPLOAD

export const ROUTERPATH = ''
export const NAMESPACE = (process.env.NODE_ENV === 'production' ? '../' : (process.env.VUE_APP_NAMESPACE_LOC || '//localhost/appcral/'))
